import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import {waLink} from '../data/site';
const {FiHome,FiKey,FiTrendingUp,FiArrowRight}=FiIcons;
const services=[
  {title: 'Buying Well',text: 'Find the right property,negotiate with confidence,and make a move that feels right long after you get the keys.',icon: FiHome,image: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?auto=format&fit=crop&w=1200&q=80'},
  {title: 'Selling Thoughtfully',text: 'A considered sale strategy,thoughtful presentation,and experienced representation at every turn.',icon: FiKey,image: 'https://images.unsplash.com/photo-1568605114967-8130e3353642?auto=format&fit=crop&w=1200&q=80'},
  {title: 'Investing Wisely',text: 'Grounded,independent perspective to help you identify opportunity and build a portfolio with purpose.',icon: FiTrendingUp,image: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?auto=format&fit=crop&w=1200&q=80'}
];
function Services() {
  return (
    <section className="section" id="services">
      <div className="havenfield-container">
        <div className="section-head center">
          <span className="eyebrow center">Here for the whole journey</span>
          <h2>Good advice.<br /><em>At every turn.</em></h2>
          <p>From first ideas to final paperwork,we bring calm,clarity,and care to every part of your property journey.</p>
        </div>
        <div className="services-grid">
          {services.map((s,i)=> (
            <motion.div className="service-card" key={i} initial={{opacity: 0,y: 24}} whileInView={{opacity: 1,y: 0}} viewport={{once: true}} transition={{duration: 0.5,delay: i * 0.1}} >
              <img src={s.image} alt={s.title} loading="lazy" />
              <div className="service-body">
                <div className="service-ic"><SafeIcon icon={s.icon} /></div>
                <h3>{s.title}</h3>
                <p>{s.text}</p>
                <a className="service-link" href={waLink(`Hello,I'm interested in your "${s.title}" service.`)} target="_blank" rel="noopener noreferrer" >
                  Enquire <SafeIcon icon={FiArrowRight} />
                </a>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
export default Services;
